import React from 'react';
import Grid from 'material-ui/Grid';
import Button from 'material-ui/Button';
import { Link } from 'react-router-dom';

class contactError extends React.Component{

  render(){
    return (
      <div className="center-container">
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <div className="contents-title-cont">
                <h1 className="contents-title">ERROR</h1>
                <p className="contents-sub-title">お問い合わせ失敗しました</p>
              </div>
              <div className="contact-result main-cont">
                  <p className="form-comment">只今サーバーエラーによりメールの送信に失敗しました<br/>
                  大変お手数ですが、しばらく時間を置いて再度お問い合わせフォームをご利用ください。
                  </p>
                  <Link to="/">
                  <Button variant="raised" size="medium" style={{marginTop:20}} color="primary">
                    Home
                  </Button>
                  </Link>
                </div>
              
            </Grid>
          </Grid>
        </div>
    )
  }
}

export default contactError;


// WEBPACK FOOTER //
// ./src/component/contact/error.js